import { motion } from 'framer-motion';
import { useState } from 'react';

export default function PartnerMerchandise() {
  const [selectedSize, setSelectedSize] = useState('M');

  const products = [
    {
      name: 'Premium Hoodie',
      hmu: 400,
      image: 'https://public.readdy.ai/ai/img_res/4fda41a609518b2290336ef9c0bfb4b8.jpg',
    },
    {
      name: 'Classic T-Shirt',
      hmu: 200,
      image: 'https://readdy.ai/api/search-image?query=stylish%20white%20t-shirt%20on%20model%20in%20clean%20studio%20setting%2C%20professional%20fashion%20photography%20with%20natural%20lighting%2C%20simple%20minimalist%20background%2C%20contemporary%20casual%20wear%2C%20premium%20cotton%20apparel&width=400&height=400&seq=tshirt-001&orientation=squarish',
    },
    {
      name: 'Digital Course Bundle',
      hmu: 150,
      image: 'https://readdy.ai/api/search-image?query=modern%20digital%20learning%20course%20materials%20on%20laptop%20screen%2C%20online%20education%20platform%20interface%2C%20professional%20workspace%20with%20notebook%20and%20coffee%2C%20clean%20minimalist%20aesthetic%2C%20e-learning%20concept&width=400&height=400&seq=digital-001&orientation=squarish',
    },
    {
      name: 'Exclusive Cap',
      hmu: 180,
      image: 'https://readdy.ai/api/search-image?query=premium%20baseball%20cap%20on%20display%20stand%2C%20professional%20product%20photography%20with%20soft%20shadows%2C%20clean%20white%20background%2C%20modern%20streetwear%20accessory%2C%20high%20quality%20headwear%20showcase&width=400&height=400&seq=cap-001&orientation=squarish',
    },
  ];

  return (
    <section id="rewards" className="py-24 bg-gradient-to-b from-honey-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Hero Product Display */}
        <div className="grid lg:grid-cols-[45%_55%] gap-12 mb-20">
          {/* Left - Product Images */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=stylish%20person%20wearing%20premium%20black%20hoodie%20in%20urban%20setting%2C%20professional%20lifestyle%20photography%20with%20natural%20lighting%2C%20modern%20streetwear%20fashion%20on%20model%2C%20clean%20contemporary%20aesthetic%2C%20high-end%20apparel%20showcase%20with%20simple%20background&width=800&height=900&seq=hero-hoodie-001&orientation=portrait"
                alt="B.E. Wear Premium Hoodie"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            {/* Floating Product Images */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="absolute -bottom-6 -right-6 grid grid-cols-2 gap-3"
            >
              {['https://readdy.ai/api/search-image?query=white%20t-shirt%20flat%20lay%20on%20clean%20surface%2C%20minimalist%20product%20photography%2C%20simple%20background%2C%20modern%20apparel%20design&width=150&height=150&seq=tshirt-thumb-001&orientation=squarish',
                'https://readdy.ai/api/search-image?query=stylish%20cap%20accessory%20on%20display%2C%20clean%20product%20shot%2C%20minimalist%20background%2C%20modern%20headwear&width=150&height=150&seq=cap-thumb-001&orientation=squarish'].map((img, i) => (
                <div key={i} className="w-24 h-24 rounded-2xl overflow-hidden shadow-lg bg-white">
                  <img src={img} alt="" className="w-full h-full object-cover object-top" />
                </div>
              ))}
            </motion.div>
          </motion.div>

          {/* Right - Product Info */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex flex-col justify-center"
          >
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-honey-500 text-white text-xs font-bold rounded-full uppercase tracking-wide">
                Partner Exclusive
              </span>
            </div>

            <h2 className="text-5xl font-bold text-charcoal-800 mb-4">
              B.E. Wear Premium Hoodie
            </h2>

            <div className="flex items-center gap-3 mb-6">
              <i className="ri-coin-fill text-5xl text-honey-500"></i>
              <span className="text-6xl font-bold text-honey-600">400</span>
              <span className="text-xl text-gray-600">HMUs</span>
            </div>

            <p className="text-gray-600 leading-relaxed mb-8">
              Premium quality hoodie from our exclusive partner B.E. Wear Apparel. Made with sustainable materials and designed for ultimate comfort. Each purchase supports our partner network and earns you additional CPV/CCV rewards.
            </p>

            {/* Size Selector */}
            <div className="mb-8">
              <div className="text-sm font-semibold text-charcoal-800 mb-3">Select Size</div>
              <div className="flex gap-3">
                {['S', 'M', 'L', 'XL'].map((size) => (
                  <button
                    key={size}
                    onClick={() => setSelectedSize(size)}
                    className={`w-14 h-14 rounded-full font-bold transition-all whitespace-nowrap ${
                      selectedSize === size
                        ? 'bg-charcoal-800 text-white scale-110'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-3 mb-6">
              <button className="w-full py-4 bg-honey-500 text-white rounded-xl font-bold text-lg hover:bg-honey-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
                Redeem with HMUs
              </button>
              <button className="w-full py-4 border-2 border-honey-500 text-honey-600 rounded-xl font-bold text-lg hover:bg-honey-50 transition-all whitespace-nowrap">
                Add to Wishlist
              </button>
            </div>

            {/* CPV/CCV Info */}
            <div className="bg-gray-100 rounded-xl p-4">
              <div className="text-xs text-gray-600 mb-2">Earning Potential</div>
              <div className="flex gap-6">
                <div>
                  <span className="text-sm font-semibold text-charcoal-800">+5 HMU</span>
                  <span className="text-xs text-gray-600"> per view</span>
                </div>
                <div>
                  <span className="text-sm font-semibold text-charcoal-800">+50 HMU</span>
                  <span className="text-xs text-gray-600"> per conversion</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Product Grid */}
        <div>
          <h3 className="text-3xl font-bold text-charcoal-800 mb-8">More Exclusive Merchandise</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {products.map((product, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -4 }}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all cursor-pointer"
              >
                <div className="w-full h-64 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <h4 className="font-bold text-charcoal-800 mb-2">{product.name}</h4>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1">
                      <i className="ri-coin-fill text-xl text-honey-500"></i>
                      <span className="text-lg font-bold text-honey-600">{product.hmu}</span>
                    </div>
                    <button className="px-4 py-2 bg-charcoal-800 text-white rounded-lg text-sm font-semibold hover:bg-charcoal-700 transition-all whitespace-nowrap">
                      Redeem
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
